<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Dernière Parution" />
            <ParuTion />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ParuTion from '../Parution/ParuTion.vue'

export default {
    name: 'ParutionPage',
    components: {
        NavBar,
        PageTitle,
        ParuTion ,
        FooterComp,
    }
}
</script>